module.exports = __webpack_public_path__ + "static/media/dashboard.030b3b46.svg";